import { MachineContext } from 'contexts/machine.context';
import { isFuture } from 'date-fns';
import useLatest from 'hooks/useLatestRef';
import { useContext, useEffect } from 'react';
import useMachineStatusStore from 'stores/use-machine-status-store';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

const useEndTrainingListener = () => {
  const lastTrainingEnded = useTrainedMsStore((s) => s.lastTrainingEnded);
  const { isActive, setAutoFire, onEndTraining } = useContext(MachineContext);
  const latestOnEndTraining = useLatest(onEndTraining);

  useEffect(() => {
    if (!lastTrainingEnded) {
      // training hasn't ended
      return;
    }

    if (!isActive) {
      // only trigger for the active user
      return;
    }

    // immediately stop auto-firing so that isFiring will eventually be false
    setAutoFire(false);

    const interval = setInterval(() => {
      const isFiring = isFuture(
        useMachineStatusStore.getState().fireStateDates.awaitFiringUntil
      );

      if (isFiring) {
        // keep waiting
        return;
      }

      // stop checking
      clearInterval(interval);

      // trigger the callback
      latestOnEndTraining.current();
    }, 500);

    return () => clearInterval(interval);
  }, [lastTrainingEnded, isActive]);
};

export default useEndTrainingListener;
